import TeeColorPicker from './TeeColorPicker'

export default TeeColorPicker
